import api from "./api";

export const getAsyncTasks = (page, params) => {
  return api.get("admin/AsyncTask", { params: { page: page, limit: 5, ...params}});
};

